// extracted by mini-css-extract-plugin
export var details = "_fe-0";
export var inspectorPopover = "_fe-1";